import { render, staticRenderFns } from "./readRecord.vue?vue&type=template&id=0d285485&scoped=true&"
import script from "./readRecord.vue?vue&type=script&lang=js&"
export * from "./readRecord.vue?vue&type=script&lang=js&"
import style0 from "./readRecord.vue?vue&type=style&index=0&id=0d285485&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d285485",
  null
  
)

export default component.exports